import { render, staticRenderFns } from "./BiologicalWarningReport.vue?vue&type=template&id=575e649f&scoped=true"
import script from "./BiologicalWarningReport.vue?vue&type=script&lang=js"
export * from "./BiologicalWarningReport.vue?vue&type=script&lang=js"
import style0 from "./BiologicalWarningReport.vue?vue&type=style&index=0&id=575e649f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e649f",
  null
  
)

export default component.exports